import { render, staticRenderFns } from "./apartments-overview-faq.vue?vue&type=template&id=4cdc5603&scoped=true&"
import script from "./apartments-overview-faq.ts?vue&type=script&lang=ts&"
export * from "./apartments-overview-faq.ts?vue&type=script&lang=ts&"
import style0 from "./apartments-overview-faq.scss?vue&type=style&index=0&id=4cdc5603&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdc5603",
  null
  
)

export default component.exports